import { createWebHashHistory, createRouter } from 'vue-router';
import { storeToRefs } from 'pinia';
import { useUserStore, useMainStatusStore } from '../store';
import IndexLayout from '../layouts/IndexLayout.vue';
const routes = [{
  path: '/',
  component: IndexLayout,
  redirect: '/home',
  children: [{
    path: '/home',
    component: () => import( /* webpackChunkName: "home" */'../views/HomePage.vue')
  }, {
    path: '/result',
    component: () => import( /* webpackChunkName: "result" */'../views/ResultPage.vue')
  }, {
    path: '/personalspace',
    component: () => import( /* webpackChunkName: "personalspace" */'../views/personalspace/IndexPage.vue')
  }, {
    path: '/preview',
    component: () => import( /* webpackChunkName: "preview" */'../views/PreviewPage.vue')
  }]
}, {
  path: '/mobile',
  component: () => import( /* webpackChunkName: "mobile" */'../views/MobilePage.vue')
}, {
  path: '/thumbnail',
  component: () => import( /* webpackChunkName: "thumbnail" */'../views/webPPT/components/thumbnail/ThumbnailRouter.vue')
}];
const router = createRouter({
  history: createWebHashHistory(),
  routes
});
const {
  VUE_APP_LOGIN_URL: loginUrl
} = process.env;
router.beforeEach((to, from, next) => {
  const useStore = useUserStore();
  const {
    isLogin,
    isSvip,
    isSlideVip,
    isShowVipWindow
  } = storeToRefs(useStore);
  const useMainStore = useMainStatusStore();
  const {
    remainInfo,
    createType
  } = storeToRefs(useMainStore);
  if (from.path === '/home' && to.path === '/result') {
    var _to$query;
    if (!unref(isLogin)) {
      // const redirectUrl = window.location.href;
      // window.location.href = `${loginUrl}?redirect_url=${encodeURIComponent(redirectUrl)}}`;
      next();
    } else if (unref(remainInfo).createOutlineRemain <= 0 && (to === null || to === void 0 ? void 0 : (_to$query = to.query) === null || _to$query === void 0 ? void 0 : _to$query.from) !== 'history' && unref(createType) !== 'EXAMPLE') {
      if (unref(isSvip) || unref(isSlideVip)) {
        useStore.changeShowVipWindow(true);
      } else {
        showToast({
          message: '开通会员，畅享PPT生成60次/月，海量风格任你选',
          className: 'c-toast',
          duration: 2000,
          zIndex: 10000
        });
        if (unref(createType) === 'TOPIC') {
          useStore.changeSvipSource('AIPPT_web_title_to_ppt_create_markdown_button');
        } else if (unref(createType) === 'CONTEXT') {
          useStore.changeSvipSource('AIPPT_web_text_to_ppt_create_markdown_button');
        }
        useStore.changeVipShow(true);
      }
    } else next();
  } else next();
});
export default router;